import { client } from "@/http/client"

import { IResponse, IPagingResponse, IRequestParams } from "@/types/api"
import { ICarrier, ICarrierCreate, ICarrierUpdate } from "@/types/ICarrier"

export interface ICarrierForOrderParam {
  Date: Date
}

export const getCarriers = (params: IRequestParams): Promise<IPagingResponse<ICarrier>> =>
  client.get("/Carriers", {
    params
  })

export const getCarriersSelectList = (): Promise<IResponse<ICarrier[]>> =>
  client.get("/Carriers/selectList")

export const getCarrierById = (id: number): Promise<IResponse<ICarrier>> =>
    client.get(`/Carriers/${id}`)

export const createCarrier = (
    body: ICarrierCreate
) : Promise<IResponse<number>> => client.post("/Carriers", body)

export const updateCarrier = (
    body: ICarrierUpdate
) : Promise<IResponse<number>> => client.put("/Carriers", body)